<script setup lang="ts">
    import { ref } from 'vue';
    import IconButton from './IconButton.vue';
    import { TextInputWidth } from './TextInput.vue';
    import { __ } from '../stores/expressions';
    import { EyeIcon, EyeOffIcon, LockIcon } from '@lucide/vue';

    const modelValue = defineModel<string>({ default: '' });

    withDefaults(
        defineProps<{
            placeholder?: string;
            autocomplete?: string;
        }>(),
        {
            placeholder: undefined,
            autocomplete: 'current-password',
        }
    );

    const showPassword = ref(false);

    const togglePasswordVisibility = () => {
        showPassword.value = !showPassword.value;
    };
</script>

<template>
    <div class="relative mb-5">
        <div class="relative">
            <LockIcon class="size-5 absolute top-3 left-3 pointer-events-none" />
            <input
                v-model="modelValue"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="placeholder"
                :autocomplete="autocomplete"
                class="TextInput pl-10 pr-12"
                :class="TextInputWidth.Full"
            />
            <div class="absolute top-1/2 -translate-y-1/2 right-1.5">
                <IconButton
                    size="size-5"
                    :aria-label="showPassword ? __('hide-password') : __('show-password')"
                    :tooltip="showPassword ? __('hide-password') : __('show-password')"
                    @click="togglePasswordVisibility"
                >
                    <EyeOffIcon v-if="showPassword" class="size-5" />
                    <EyeIcon v-else class="size-5" />
                </IconButton>
            </div>
        </div>
    </div>
</template>
